import { render, staticRenderFns } from "./RemoveGroupDevice.vue?vue&type=template&id=18f5ad14&scoped=true"
import script from "./RemoveGroupDevice.vue?vue&type=script&lang=js"
export * from "./RemoveGroupDevice.vue?vue&type=script&lang=js"
import style0 from "./RemoveGroupDevice.vue?vue&type=style&index=0&id=18f5ad14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f5ad14",
  null
  
)

export default component.exports